import React, { useEffect, useState } from "react";
import AnalyticsDataService from "../../services/analytics";
import { MonthlyBarChart } from "../../Component/Analytics/MonthlyBarChart";
import { DateRangeBarChart } from "../../Component/Analytics/DateRangeBarChart";
import { Box, Button, Text, VStack } from "@chakra-ui/react";

export const BookingRecords = () => {
  const token = localStorage.getItem("logged_in_user_token");

  const [viewMode, setViewMode] = useState("last30Days");


  const [appBookingMonthlyData, setAppBookingMonthlyData] = useState<any>([]);

  const [nonAppbookingMonthlyData, setNonAppBookingMonthlyData] = useState<any>(
    []
  );


  const toggleViewMode = () => {
    setViewMode(viewMode === "last30Days" ? "currentmonth" : "last30Days");
  };
  const getDateFormat = (dateString: string) => {
    let date = new Date(dateString);
    let day = date.getDate();
    let monthIndex = date.getMonth();
    let year = date.getFullYear();
    let monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    let monthName = monthNames[monthIndex];
    let newDateString = day + "-" + monthName + "-" + year;
    return newDateString;
  };

  const calculateSumAfterRemovingLastN = (arr: any[], n: number) => {
    const modifiedArray = n > 0 ? arr.slice(0, -n) : arr;

    const totalSum = modifiedArray.reduce((sum, obj) => sum + obj.count, 0);

    // const average = (totalSum / modifiedArray.length).toFixed(2);

    return totalSum;
  };

  const fetchBookingMonthlyData = () => {
    AnalyticsDataService.getBookingMonthlyData(viewMode)
      .then((res: any) => {
        const appBookings = res.data.appBookings.map((item: any) => {
          return {
            date: getDateFormat(item.date),
            count: item.count,
            App: 0,
          };
        });
        const nonAppBookings = res.data.nonAppBookings.map((item: any) => {
          return {
            date: getDateFormat(item.date),
            count: item.count,
            App: 0,
          };
        });
        setAppBookingMonthlyData(appBookings);
        setNonAppBookingMonthlyData(nonAppBookings);
      })
      .catch((e: any) => {
        console.log(e);
      });
  };


  useEffect(() => {
    fetchBookingMonthlyData();
  }, [viewMode]);
  return (
    <>
      <Box
        bg="#e98b90"
        color="white"
        fontWeight="bold"
        textAlign="center"
        textColor="black"
        py={4}
        px={6}
      >
        {viewMode === "last30Days"
          ? "Last 30 Days Report"
          : "Current Month Report"}
      </Box>
      <Box px={6} py={6} maxW="100%" bg="gray.50">
        <Button type="button" onClick={toggleViewMode} colorScheme="teal">
          {viewMode === "last30Days" ? "Current Month" : "Last 30 Days"}
        </Button>
        <VStack align="start" spacing={0}>
          <Text fontSize="lg" fontWeight="bold" mb={3} mt={8}>
            {`Daily App Bookings (Total App Bookings : ${calculateSumAfterRemovingLastN(
              appBookingMonthlyData,
              0
            )})`}
          </Text>

          {appBookingMonthlyData && (
            <Box w="100%" mt={6}>
              <MonthlyBarChart data={appBookingMonthlyData} />
            </Box>
          )}

          <Text fontSize="lg" fontWeight="bold" mb={3} mt={8}>
            {`Daily Provisional Bookings (Total Non App Bookings : ${calculateSumAfterRemovingLastN(
              nonAppbookingMonthlyData,
              0
            )})`}
          </Text>

          {nonAppbookingMonthlyData && (
            <div className="chart-container">
              <MonthlyBarChart data={nonAppbookingMonthlyData} />
            </div>
          )}
        </VStack>
      </Box>
    </>
  );
};
